import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('breadcrumb', {
    attrs: {
      "data": _vm.breadcrumbData
    }
  }), _c('tip'), _c('inbound-delivery-order-charge', _vm._b({}, 'inbound-delivery-order-charge', {
    orderCodeText: _vm.t('货运单号')
  }, false))], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };